module.exports = __webpack_public_path__ + "static/media/logo.d5a0ca3f.png";